angular.module('iconoglobe')
.factory('MetaUtilService',['$rootScope', function ($rootScope) {
    
    var isLocked = false;

    var metaInformation = function (metaData) {
        if (!metaData) return;

        // 🔒 HARD LOCK
        if (isLocked) {
         //   console.log("MetaUtilService: HARD LOCK - ignoring update", metaData);
            return;
        }

        // 🔥 LOCK on broadcast
        if (metaData.isBroadcast) {
            isLocked = true;
         //   console.log("MetaUtilService: LOCK ACTIVATED (broadcast)");
        }

        // ✅ SET META
    //    console.trace("META SET CALLED WITH:", metaData.pageTitle)
        $rootScope.metaTitle = metaData.pageTitle || '';
        $rootScope.metaKeywords = metaData.metaKeywords || '';
        $rootScope.metaDescription = metaData.metaDescription || '';

        var img = metaData.metaOgImage || "ogiconoglobe.png";
        $rootScope.metaOgImage = img.indexOf('http') > -1 
            ? img 
            : "https://iconoglobe.com/i-i/" + img;

       // console.log("meta----updated", $rootScope.metaTitle, $rootScope.metaOgImage);

        if (metaData.isBroadcast) {
            window.prerenderReady = true;
        }
    };

    return {
        metaInformation: metaInformation
    }; 
}]);